import {
  ReactSelect,
  CustomInput,
  SeparatorInput,
} from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";
import { useState } from "react";
import { PlusIcon } from "../../kits/Icons";
import BankAccountList from "./BankAccountList";
import { removePatternFormat } from "react-number-format";
export default function AddBankAccount({
  bankNameOption,
  customerData,
  mainDataHandler,
}) {
  console.log("customerData", customerData);
  const [data, setData] = useState({
    card_number: { formattedValue: "", value: "", floatValue: "" },
    sheba_number: { formattedValue: "", value: "", floatValue: "" },
    bankName: "",
    account_number: "",
  });
  const [textErr, setTextErr] = useState({
    account_number: "",
    card_number: "",
    sheba_number: "",
  });
  const dataHandler = (name, value) => {
    setData((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const errorHandler = (name, value) => {
    setTextErr((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const validation = () => {
    let validate = true;
    if (
      data.card_number != undefined &&
      data.card_number?.value?.length == 16
    ) {
      errorHandler("card_number", "");
    } else {
      errorHandler("card_number", "شماره کارت را به درستی وارد کنید!");
      validate = false;
    }
    if (
      data.sheba_number != undefined &&
      data.sheba_number?.value?.length == 24
    ) {
      errorHandler("sheba_number", "");
    } else {
      errorHandler("sheba_number", "شماره شبا را به درستی وارد کنید!");
      validate = false;
    }
    return validate;
  };
  console.log("object", customerData);
  return (
    <div className="d-flex flex-wrap mt-4">
      <div className="col-12 d-flex">
        <h4 className="mt-2">افزودن کارت </h4>
        <div className="ms-auto my-1 pe-1">
          <CustomButton
            size="small"
            color="success"
            onClick={() => {
              if (validation()) {
                mainDataHandler("bankAccount", {
                  ...data,
                  bankName: data.bankName.label,
                  bank_id: data.bankName.value,
                });
                setData({
                  card_number: {
                    formattedValue: "",
                    value: "",
                    floatValue: "",
                  },
                  sheba_number: {
                    formattedValue: "",
                    value: "",
                    floatValue: "",
                  },
                  bankName: "",
                  account_number: "",
                });
              }
            }}
          >
            <PlusIcon />
          </CustomButton>
        </div>
      </div>
      <ReactSelect
        inputContainer="col-sm-6 col-12 px-1 my-1"
        isMulti={false}
        itemsList={bankNameOption}
        inputSize="text"
        title="نام بانک"
        inputValue={data?.bankName}
        onChangeFunc={(e) => {
          dataHandler("bankName", e);
        }}
      />
      <CustomInput
        inputContainer="col-sm-6 col-12 px-1 my-1"
        label="شماره حساب"
        inputSize="text"
        inputValue={data?.account_number}
        onChangeFunc={(e) => {
          if (isNaN(e.target.value)) {
            errorHandler("account_number", "فقط عدد وارد کنید!");
          } else {
            dataHandler("account_number", e.target.value);
            errorHandler("account_number", "");
          }
        }}
      />

      <SeparatorInput
        inputContainer="col-sm-6 col-12 px-1 my-1"
        inputValue={data?.sheba_number?.formattedValue}
        formatCustom="IR-########################"
        label="شماره شبا"
        placeholder="نمونه:IR-123456789999999999999999"
        inputSize="text"
        textErr={textErr.sheba_number}
        onChangeFunc={(e) => {
          // console.log(e.value.length, textErr);
          // if (e.value.length >= 24) {
          //   errorHandler("sheba_number", "شماره شبا باید 24 رقم باشد!");
          // } else {
          dataHandler("sheba_number", e);
          // errorHandler("sheba_number", "");
          // }
        }}
      />
      <SeparatorInput
        inputContainer="col-sm-6 col-12 px-1 my-1"
        inputValue={data?.card_number?.formattedValue}
        formatCustom="####-####-####-####"
        label="شماره کارت"
        placeholder="1111-2222-3333-4444"
        inputSize="text"
        textErr={textErr.card_number}
        onChangeFunc={(e) => {
          // if (e.value.length >= 16) {
          //   errorHandler("card_number", "شماره کارت باید 16 رقم باشد!");
          // } else {
          dataHandler("card_number", e);
          // errorHandler("card_number", "");
          // }
        }}
      />

      <div className="col-12 my-1">
        <BankAccountList
          data={customerData.bankAccount}
          type="noOperation"
          bankName={bankNameOption}
          mainDataHandler={mainDataHandler}
        />
      </div>
    </div>
  );
}
